var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"energy-classes__item"},[_vm._v(_vm._s(_vm.letter)),(_vm.hasQuantifiers)?_c('EnergyClassesQuantifiers',{attrs:{"value":_vm.quantifiers}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }